import { money } from './money.js';
const DATE_RE = /^\d{4}-\d{2}-\d{2}$/;
const DATETIME_RE = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/;
export function canonicalString(doc) {
    if (!DATE_RE.test(doc.issueDate))
        throw new Error(`issueDate inválida: ${doc.issueDate}`);
    if (!DATETIME_RE.test(doc.systemEntryDate))
        throw new Error(`systemEntryDate inválida: ${doc.systemEntryDate}`);
    if (!doc.documentNumber.trim())
        throw new Error('documentNumber vazio');
    return [doc.issueDate, doc.systemEntryDate, doc.documentNumber, money(doc.grossTotal), doc.previousHash].join(';');
}
/**
 * Cadeia que o produtor assina para certificar a chave de um terminal. A
 * chave pública entra normalizada (só o base64, sem cabeçalhos nem quebras),
 * para a mesma chave dar sempre a mesma cadeia.
 */
export function deviceCertificateString(c) {
    for (const [k, v] of Object.entries(c)) {
        if (typeof v !== 'string' || !v.trim())
            throw new Error(`Certificado: ${k} vazio`);
        if (k !== 'publicKeyPem' && v.includes(';'))
            throw new Error(`Certificado: ${k} não pode ter ';'`);
    }
    const key = c.publicKeyPem.replace(/-----[^-]+-----/g, '').replace(/\s+/g, '');
    return ['makila-pos-device-v1', c.keyId, c.tenantId, c.terminalId, key, c.issuedAt].join(';');
}
//# sourceMappingURL=canonical.js.map